export const journeyTypes = {
  BOTH_WAYS: 'BOTH_WAYS',
  OUTBOUND_ONLY: 'OUTBOUND_ONLY',
  RETURN_ONLY: 'RETURN_ONLY',
};
